import React, { useState, useEffect } from 'react'
import { FooterButtons } from './FooterButtons'
import { ConfirmModal } from '../../Modals/ConfirmModal'
import { IApplicationState } from '../../../../Store'
import { useSelector } from 'react-redux';
import { useSaveFormulaire } from '../../../../lib/formulaireContext/hooks/useSaveFormulaire'
import { UseFormMethods } from 'react-hook-form'
import { FormulaireSchemaType } from '../../../../lib/formulaireContext/validation/formulaire.schema'
import { userFormIdentity, getConfirmModalContent } from '../../Modals/ModalContent'



export const FormFooter = ({ form }: { form: UseFormMethods<FormulaireSchemaType> }) => {
    const i18n = useSelector((state: IApplicationState) => state.i18n.i18n)
    const formulaire = useSelector(
      (state: IApplicationState) => state.formulaire['fr']
    );
    const userInfo = useSelector((state: IApplicationState) => state.user.userInfo)
    const isLoading = useSelector((state: IApplicationState) => state.formulaire.isLoading)
    const isSaving = useSelector((state: IApplicationState) => state.formulaire.isSaving)
    const { saveFormulaire } = useSaveFormulaire()

    const [openConfirmModal, setOpenConfirmModal] = useState(false)
    const [openSuccessModal, setOpenSuccessModal] = useState(false)
    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [isValidated, setIsValidated] = useState(false)
    const [shouldDownload, setShouldDownload] = useState(false)
    const [hasSaved, setHasSaved] = useState(false)

    const handleSave = () => {
        if (formulaire && userInfo) {
            if (!form.formState.isValid) {
                form.trigger();
            }
            saveFormulaire(form.watch(), isValidated, formulaire.envelope_status === 'completed', shouldDownload)
            setHasSaved(true)
        }
    }

    const handleOpenSuccessModal = (title: string, description: string) => {
        setOpenSuccessModal(true)
        setTitle(title)
        setDescription(description)
    }

    const handleCloseConfirmModal = () => {
        setOpenConfirmModal(false)
    }
    const handleOpenConfirmModal = (validated: boolean, shouldDownload: boolean, title: string, description: string) => {
        setIsValidated(validated)
        setShouldDownload(shouldDownload)
        setOpenConfirmModal(true)
        setTitle(title)
        setDescription(description)
    }

    const handleSaveDraft = () => {
        handleOpenConfirmModal(false, false, 'Enregistrer le brouillon ?', 'Voulez-vous vraiment enregistrer le brouillon ?')
    }
    const handleDownloadPDF = () => {
        handleOpenConfirmModal(false, true, 'Télécharger le formulaire ?', 'Êtes vous sûr(e) d\'enregistrer ce document ?')
    }
    const handleSign = () => {
        handleOpenConfirmModal(true, false, 'Signer ma déclaration', userFormIdentity(userInfo, i18n) as any)
    }
    const handleSendToSacem = () => {
        handleOpenConfirmModal(true, false, 'Envoyer le document signé à la sacem ?', 'Êtes vous sûr de vouloir envoyer le document signé electroniquement à la sacem ?')
    }

    useEffect(() => {
        if (!isSaving && hasSaved) {
            setOpenConfirmModal(false)
            const confirmModalContent = getConfirmModalContent(formulaire.envelope_status, isValidated, userInfo, i18n)
            handleOpenSuccessModal(confirmModalContent.title, confirmModalContent.content as any)
        }
    }, [isSaving, openConfirmModal, hasSaved])

    return (
        <>
            <FooterButtons
                isLoading={isLoading || isSaving}
                envelopeStatus={formulaire.envelope_status}
                handleDownloadPDF={handleDownloadPDF}
                handleSaveDraft={handleSaveDraft}
                handleSign={handleSign}
                handleSendToSacem={handleSendToSacem}
                formIsValid={form.formState.isValid}
            />
            <ConfirmModal
                openConfirmModal={openConfirmModal}
                handleCloseConfirmModal={handleCloseConfirmModal}
                handleConfirm={handleSave}
                title={title}
                description={description}
                cancelButtonText={i18n._('Cancel')}
                confirmButtonText={i18n._('Confirm')}
                isLoading={isSaving}
            />

            <ConfirmModal
                openConfirmModal={openSuccessModal}
                handleConfirm={() => {
                    setOpenSuccessModal(false)
                    setHasSaved(false)
                }}
                title={title}
                description={description}
            />
        </>
    )
}